import { render, staticRenderFns } from "./FacilityLicenseSelector.vue?vue&type=template&id=4ad272b5"
import script from "./FacilityLicenseSelector.vue?vue&type=script&lang=js"
export * from "./FacilityLicenseSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports